import ShortUniqueId from 'short-unique-id'
import { makePass } from '/providers/passes-api'
import _ from 'lodash'

import config from '/providers/config.json'
import instance_data from '../wizard/event/instance_data.js'

const batchSendMakePasses = async ({ apiKey, apiSource, apiMode, templateId, dataSource, passData, instanceData, setMakePassResults, setPassesToProcess }) => {
  try {

    let response = { ok: true }

    let data = dataSource === "upload" ? passData : [_.cloneDeep(instanceData)]

    // Add check here to see if we have enough capacity before we start...

    if (apiMode === "test") data = data.slice(0, config.maxTestPasses)

    if (dataSource === "sample") {
      data.map((d, i) => {
        d.__pass_id__ = shortUUID()
        return d
      })
    }

    let promises = []
    let results = []

    setPassesToProcess(data.length)

    for (let d = 0; d < data.length; d++) {
      while (promises.length >= config.maxConcurrentMakePassRequests) {
        let result = await Promise.all(promises)

        result.map(r => {
          if (r.error) {
            response = {
              ok: false,
              error: r.error
            }

            results = [...results, {
              id: r.passId,
              error: r.error?.message ?? r.error
            }]
          } else {
            results = [...results, {
              id: r.pass_id,
              appleUrl: r.appleUrl,
              googleUrl: r.googleUrl,
            }]
          }
        })

        setMakePassResults(results)

        promises = []
      }

      promises.push(sendMakePass({ apiKey, apiSource, apiMode, templateId, passId: data[d].__pass_id__, instanceData: data[d] }))
    }

    let result = await Promise.all(promises)

    result.map(r => {
      if (r.error) {

        response = {
          ok: false,
          error: r.error
        }

        results = [...results, {
          id: r.passId,
          error: r.error?.message ?? r.error
        }]
      } else {
        results = [...results, {
          id: r.pass_id,
          appleUrl: r.appleUrl,
          googleUrl: r.googleUrl,
        }]
      }
    })

    setMakePassResults(results)

    return response
  }
  catch (err) {
    console.error(err)
  }
}

export default batchSendMakePasses


const sendMakePass = async ({ apiKey, apiSource, apiMode, templateId, passId, instanceData }) => {
  const passData = {instance_data: instanceData}
  const result = await makePass({ apiKey, apiSource, apiMode, templateId, passId, passData})

  return { ...result, passId }
}

const shortUuidDictionary = [
  '0', '1', '2', '3',
  '4', '5', '6', '7',
  '8', '9', 'A', 'B',
  'C', 'D', 'E', 'F',
  'G', 'H', 'J', 'K',
  'L', 'M', 'N', 'P', 'Q',
  'R', 'T', 'U', 'V', 'W',
  'X', 'Y'
]

function shortUUID() {
  const uid = new ShortUniqueId({ length: 12, dictionary: shortUuidDictionary })
  const uuid = uid.rnd()

  const uuidArray = uuid.match(/.{1,4}/g)
  const formattedUUID = uuidArray.join("-")

  return formattedUUID
}
